// import { deviceSystemAgeOptions } from "constants/DeviceSystemAgeOptions"
import { contractorPerformanceTestHistoryStatusOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerEmail } from "components/table/columnComponents/CustomerEmail"
import { CustomerName } from "components/table/columnComponents/CustomerName"
import { StatusOfPerformanceTest } from "components/table/columnComponents/StatusOfPerformanceTest"
import { TempChangeOfPerformanceTest } from "components/table/columnComponents/TempChangeOfPerformanceTest"

const performanceTestHistoryTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Email",
    type: "sort-search",
    name: "email",
    size: "middle",
    cellComponent: CustomerEmail,
  },
  {
    title: "Status",
    type: "select",
    name: "status",
    size: "small",
    options: contractorPerformanceTestHistoryStatusOptions,
    cellComponent: StatusOfPerformanceTest,
  },
  {
    title: "Temp change",
    type: "default",
    name: "temp_change",
    size: "middle",
    cellComponent: TempChangeOfPerformanceTest,
  },
  {
    title: "Test Date",
    type: "sort-date-range",
    name: "result_date",
    size: "middle",
  },
  {
    title: "Label",
    type: "sort-search",
    name: "label",
    size: "small",
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
    size: "small",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
    size: "small",
  },
  {
    title: "ZIP code",
    type: "sort-search",
    name: "zip_code",
    size: "small",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
    size: "small",
  },
  {
    title: "Customer",
    type: "sort-search",
    name: "homeowner_name",
    size: "middle",
    cellComponent: CustomerName,
  },
  {
    title: "S/N",
    type: "sort-search",
    name: "sn",
    size: "small",
  },
  {
    title: "Activation date",
    type: "sort-date-range",
    name: "activation_date",
    size: "middle",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address",
  },
  // TODO: uncomment this when implemented in backend
  // {
  //   title: "System age",
  //   type: "select",
  //   name: "system_age",
  //   options: deviceSystemAgeOptions,
  //   size: "middle",
  // },
]

export default performanceTestHistoryTableHeaderCells
